var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-list" }, [
    _c("div", { staticClass: "list-show", on: { click: _vm.canShowDetail } }, [
      _c("label", [_vm._v(_vm._s(_vm.index))]),
      _c("span", [_vm._v(_vm._s(_vm.data.jobNo))]),
      _c(
        "div",
        [
          _c("img", {
            class: _vm.currentState === "checking" ? "animate" : "",
            attrs: { src: _vm.icon, alt: "" }
          }),
          _c(
            "el-popover",
            {
              staticStyle: { width: "100%" },
              attrs: { placement: "right", width: "400", trigger: "hover" }
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.disposeExplainData, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      property: "gpExplain",
                      label: "GP备注"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      property: "arapExplain",
                      label: "ARAP解释"
                    }
                  })
                ],
                1
              ),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.isArAp && Object.keys(_vm.explainData).length > 0,
                    expression: "isArAp && Object.keys(explainData).length > 0"
                  }
                ],
                staticStyle: { "margin-left": "10px" },
                attrs: {
                  slot: "reference",
                  src: require("@/assets/icons/bg-right.png")
                },
                slot: "reference"
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "list-hide" },
      [_vm._t("default", null, { show: _vm.showDetails })],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }